module.exports = __webpack_public_path__ + "img/NHSO_logo.784b824b.png";